import { FC, Fragment, useEffect, useState } from 'react';
import SelectCustom from 'components/ui/SelectCustom/SelectCustom';
import RadioGroup from 'components/ui/RadioGroup/RadioGroup';
import Button from 'components/ui/Button/Button';
import { Select } from 'ts/interfaces/Generic';
import Tooltip from 'components/ui/Tooltip/Tooltip';
import { onClickClose, onClickOverlay } from 'utils/responsive';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';

interface SortByProps {
  onSortChange: (sort: string) => void;
  options?: Select[];
  newSort?: string;
  showTooltip?: boolean;
  hidePlaceholder?: boolean;
}
const SortBy: FC<SortByProps> = ({ onSortChange, options, ...props }) => {
  const [sortValue, setSortValue] = useState('');
  const [t] = useTranslation();

  useEffect(() => {
    if (typeof props.newSort === 'string') {
      setSortValue(props.newSort);
    }
  }, [props.newSort]);

  const onClickSort = (value: any) => {
    onSortChange(value);
    setSortValue(value);
  };


  return (
    <Fragment>
      <div className="sort-by-item hide-laptop-sm">
        {props.showTooltip ? (
          <Tooltip content={t('sort.by')} position="top">
            <SelectCustom
              options={options as any}
              onChange={onClickSort}
              value={sortValue}
              placeholder={props.hidePlaceholder ? undefined : t('sort.by')}
              showHtmlPrev
            />
          </Tooltip>
        ) : (
          <SelectCustom
            options={options as any}
            onChange={onClickSort}
            value={sortValue}
            placeholder={props.hidePlaceholder ? undefined : t('sort.by')}
            showHtmlPrev
          />
        )}
      </div>

      {createPortal(
        <div className="sort-responsive" onClick={onClickOverlay}>
          <div className="search-inner">
            <div className="results-responsive-header">
              <span className="title text-md">{t('sort.by')}</span>
              <FontAwesomeIcon icon={faTimes} onClick={onClickClose} />
            </div>

            <div className="sort-responsive-content">
              <RadioGroup
                className="mb-10"
                options={options as any}
                onChange={setSortValue}
                value={sortValue}
                needToTranslate={true}
              />

              <Button
                title={t('apply')}
                className="w100p btn btn-primary"
                onClick={() => onClickSort(sortValue)}
              />
            </div>
          </div>
        </div>,
        document.body
      )}
    </Fragment>
  );
};

export default SortBy;
